"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var locale_1 = __importDefault(require("./locale"));
var getIn = shared_1.FormPath.getIn;
var self = shared_1.globalThisPolyfill;
var getBrowserlanguage = function () {
    if (!self.navigator) {
        return 'en';
    }
    return self.navigator.browserlanguage || self.navigator.language || 'en';
};
var LOCALE = {
    messages: {},
    lang: getBrowserlanguage()
};
var getMatchLang = function (lang) {
    var isoCode = LOCALE.lang;
    if (LOCALE.messages[lang]) {
        return lang;
    }
    shared_1.each(LOCALE.messages, function (messages, key) {
        if (key.indexOf(lang) > -1 || String(lang).indexOf(key) > -1) {
            isoCode = key;
            return false;
        }
    });
    return isoCode;
};
exports.setValidationLocale = function (locale) {
    LOCALE.messages = shared_1.merge(LOCALE.messages, locale);
};
exports.setLocale = exports.setValidationLocale;
exports.setValidationLanguage = function (lang) {
    LOCALE.lang = lang;
};
exports.setLanguage = exports.setValidationLanguage;
exports.getMessage = function (path) {
    var message = getIn(LOCALE.messages, getMatchLang(LOCALE.lang) + "." + path);
    if (!message) {
        shared_1.log.error("field is not valid,but not found " + path + " error message. Please set the language pack first through setValidationLocale");
    }
    return message || 'Field is invalid';
};
exports.setValidationLocale(locale_1.default);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/validator/lib/message.js
// module id = 1520
// module chunks = 0